<template>
  <div class="withdrawDeposit">
    <div class="header">
      <div class="price">
        {{ inviteStore.withdrawBalanceDate.balance }}
      </div>
      <div class="text">可提现金额</div>
    </div>
    <div class="main">
      <div class="money">
        <div class="title">提现金额</div>
        <div class="moneyInput">
          <div class="symbol">¥</div>
          <van-field
            class="input"
            @blur="data.moneyInputBlur"
            v-model="data.num"
            type="number"
            placeholder="请输入提现金额"
            @input="data.onInput"
          />
          <div
            class="inputBtn"
            @click="data.num = inviteStore.withdrawBalanceDate.balance"
          >
            全部提现
          </div>
        </div>
        <div class="explain">
          <div>提现说明:</div>
          <div>1.单笔最低提现20元</div>
          <div>2.提现至支付宝余额，1-3个工作日内到账</div>
          <div>3.如有疑问，请联系客服</div>
        </div>
      </div>
      <div class="aliPay">
        <div
          class="aliPayHeader"
          @click="data.openItemFlag = !data.openItemFlag"
        >
          <div class="left">
            <img class="aliIcon" src="@/assets/ali.png" alt="" />
            <div class="title">提现到支付宝</div>
          </div>
          <div class="right">
            <div class="name" v-if="data.aliName && !data.openItemFlag">
              {{ data.aliName }}
            </div>
            <van-icon name="arrow-down" style="color: #979797" />
          </div>
        </div>
        <div class="aliPayMain" v-if="data.openItemFlag">
          <div class="item">
            <van-field
              required
              v-model="data.aliUser"
              label="你的支付宝账户(用于转账使用)"
              placeholder="请输入你的支付宝账户(邮箱或手机号)"
              label-align="top"
            />
          </div>
          <div class="item">
            <van-field
              required
              v-model="data.aliName"
              label="你的真实姓名(用于验证账户的真实性)"
              placeholder="请输入你的姓名"
              label-align="top"
            />
          </div>
        </div>
      </div>
      <div class="btttom">
        <div
          class="btn"
          @click="data.refer"
          :style="
            data.aliName &&
            data.aliUser &&
            data.num <= inviteStore.withdrawBalanceDate.balance
              ? 'background: #8368FC;'
              : ''
          "
        >
          提交申请
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  defineComponent,
  defineExpose,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useInviteStore } from "@/store/invite";
import { withdrawApply } from "@/api/invite";
import { showSuccessToast, showFailToast } from "vant";
import cross from "@/assets/cross.png";
import surres from "@/assets/surres.png";
import { showNotify } from "vant";
const inviteStore = useInviteStore();
/**
 * 路由对象
 */
const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
 * 数据部分
 */
const data = reactive({});

data.openItemFlag = !(
  inviteStore.withdrawBalanceDate.account &&
  inviteStore.withdrawBalanceDate.name
);

data.aliUser = inviteStore.withdrawBalanceDate.account;

data.aliName = inviteStore.withdrawBalanceDate.name;

data.activeNames = [];

data.show = false;

data.errorMessageText = "";

data.num = "";

data.onInput = (value) => {
  const regExp = /^(\d+\.?\d{0,2}|\.\d{0,2}|\d+)$/;
  // 如果输入的值不符合我们的正则表达式，那么就修复它
  if (!regExp.test(value)) {
    data.num = data.num
      .replace(/[^0-9.]|(\..*\.)/g, "")
      .replace(/(.*\.\d{2}).*$/, "$1");
  }
};
data.moneyInputBlur = () => {
  data.num = Number(data.num).toFixed(2);
  if (Number(data.num) > Number(inviteStore.withdrawBalanceDate.balance)) {
    showFailToast({
      message: "可提现金额为" + inviteStore.withdrawBalanceDate.balance,
      wordBreak: "break-word",
      icon: cross,
    });
    return false;
  }
};

data.refer = () => {
  if (
    data.aliName &&
    data.aliUser &&
    Number(data.num) <= Number(inviteStore.withdrawBalanceDate.balance)
  ) {
    if (Number(data.num) < 20) {
      showFailToast({
        message: "单笔最低提现金额为20元",
        wordBreak: "break-word",
        icon: cross,
      });
      return false;
    }
    withdrawApply({
      amount: String(data.num),
      type: "ALIPAY",
      name: data.aliName,
      account: data.aliUser,
    }).then((res) => {
      if (res.code === 200) {
        data.num = "";
        showSuccessToast({
          message: "申请成功",
          icon: surres,
        });
        inviteStore.getTeamInfo();
        inviteStore.getWithdrawBalance();
      }
    });
  } else if (
    Number(data.num) > Number(inviteStore.withdrawBalanceDate.balance)
  ) {
    showFailToast({
      message: "可提现金额为" + inviteStore.withdrawBalanceDate.balance,
      wordBreak: "break-word",
      icon: cross,
    });
    return false;
  }
};

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  inviteStore.getWithdrawBalance();
  inviteStore.getTeamInfo();
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});
watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.withdrawDeposit::-webkit-scrollbar {
  width: 0 !important;
}
.withdrawDeposit {
  height: calc(100vh - 120px);
  overflow-y: auto;
  .header {
    margin-top: 64px;
    margin-bottom: 48px;
    text-align: center;
    color: #ffffff;
    .price {
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      font-size: 72px;
    }
    .text {
      font-size: 28px;
      font-weight: 400;
      color: #f7f5ff;
    }
  }
  .main {
    padding: 0 24px;
    .money {
      padding: 24px;
      background: #1d2234;
      border-radius: 24px;
      .title {
        font-weight: 400;
        color: #f7f5ff;
        font-size: 28px;
      }
      .moneyInput {
        margin-top: 40px;
        padding-bottom: 5px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f7f5ff30;
        :deep(.van-field__control::-webkit-input-placeholder) {
          color: #f7f5ff50;
          font-size: 24px;
        }
        .symbol {
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #f7f5ff;
          font-size: 32px;
        }
        .input {
          flex: 1;
          background: transparent;
        }
        .van-cell::after {
          display: none;
        }
        .inputBtn {
          font-weight: 400;
          color: #8368fc;
          font-size: 24px;
        }
      }
      .explain {
        margin-top: 36px;
        font-weight: 400;
        color: #f7f5ff99;
        font-size: 26px;
      }
    }
  }
  .aliPay {
    margin-top: 24px;
    background: #1d2234;
    border-radius: 24px;
    padding: 24px;
    .aliPayHeader {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        font-weight: 400;
        color: #ffffff;
        font-size: 28px;
        .aliIcon {
          margin-right: 16px;
          width: 48px;
          height: 48px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        .name {
          font-weight: 400;
          color: #ffffff;
          font-size: 28px;
          margin-right: 24px;
        }
      }
    }
    .aliPayMain {
      opacity: 1;
      .item {
        margin-top: 32px;
        .van-cell {
          background: transparent;
          ::v-deep().van-field__label--top {
            margin-bottom: 16px !important;
            font-size: 26px;
          }
          :deep(.van-field__control::-webkit-input-placeholder) {
            font-weight: 400;
            color: #f7f5ff60;
            font-size: 28px;
          }
          ::v-deep().van-field__control {
            height: 88px;
            background: #323647;
            border-radius: 16px;
            padding: 0 32px;
          }
        }
      }
      .item:nth-child(2) {
        margin-top: 48px;
      }
    }
  }
  .btttom {
    padding: 64px;
    padding-bottom: 34px;
    .btn {
      padding: 23px 0;
      text-align: center;
      background: #f7f5ff43;
      border-radius: 44px;
      font-weight: 500;
      color: #ffffff;
      font-size: 30px;
    }
  }
}
</style>
